import { Navigate } from "react-router-dom";
import { PATH_AUTH } from "src/routes/paths";

const Confirmation = () => <Navigate to={PATH_AUTH.signIn} replace />;
export default Confirmation;
